/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
import jQuery from 'jquery';
import 'react-datepicker/dist/react-datepicker.css';
import { setConfig } from 'react-hot-loader';
import * as Sentry from '@sentry/browser';
import cssVars from 'css-vars-ponyfill';
import { clearAllTimeouts } from './src/utils';
export default () => {
  clearAllTimeouts();

  if (typeof window !== 'undefined') {
    window.$ = jQuery;
    window.jQuery = jQuery;
    require('whatwg-fetch');
    require('promise-polyfill/src/polyfill');
    cssVars({
      watch: true,
      onError(message, elm, xhr, url) {
        console.log(message); // 1
        console.log(elm); // 2
        console.log(xhr.status); // 3
        console.log(xhr.statusText); // 4
        console.log(url); // 5
      },
      onComplete(cssText, styleElms, cssVariables, benchmark) {
        console.log('styleElms', styleElms);
        console.log('cssText', cssText);
        console.log('cssVariables', cssVariables);
        console.log('benchmark', benchmark);
      },
    });
  }
  setConfig({
    // set this flag to support SFC if patch is not landed
    pureSFC: true,
  });

  if (process.env.GATSBY_SENTRY_ENV) {
    Sentry.init({
      dsn: 'https://bcf57750cd4c45f1bf1a06d0a8924ce2@sentry.io/1456514',
      environment: process.env.GATSBY_SENTRY_ENV,
    });
  }

  if (process.env.GATSBY_HEAP_ID) {
    (function () {
      (window.heap = window.heap || []),
      (heap.load = function (e, t) {
        (window.heap.appid = e), (window.heap.config = t = t || {});
        var r = t.forceSSL || 'https:' === document.location.protocol,
          a = document.createElement('script');

        (a.type = 'text/javascript'),
        (a.async = !0),
        (a.src =
              (r ? 'https:' : 'http:') +
              '//cdn.heapanalytics.com/js/heap-' +
              e +
              '.js');

        var n = document.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(a, n);

        for (
          var o = function (e) {
              return function () {
                heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
              };
            },
            p = [
              'addEventProperties',
              'addUserProperties',
              'clearEventProperties',
              'identify',
              'resetIdentity',
              'removeEventProperty',
              'setEventProperties',
              'track',
              'unsetEventProperty',
            ],
            c = 0;
          c < p.length;
          c++
        ) {
          heap[p[c]] = o(p[c]);
        }
      });
      heap.load(process.env.GATSBY_HEAP_ID);
    })();
  }
  Number.prototype.round = function (places) {
    return +(Math.round(this + 'e+' + places) + 'e-' + places);
  };
};
